var r = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e.TERTIARY = "tertiary", e.DELETE = "delete", e.LINK = "link", e))(r || {});
export {
  r as ButtonVariant
};
//# sourceMappingURL=ButtonVariant.type.mjs.map
